import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DirectorModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { IDirectorsService } from "services/DirectorsService";

const initialState = {
  Directors: new Array<DirectorModel>(),
  IncludeDeleted: false,
  LoadingDirectors: false,
};

export const directorsTableSlice = createSlice({
  name: "directors",
  initialState,
  reducers: {
    setIncludeDeleted: (state, action) => {
      state.IncludeDeleted = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDirectors.pending, (state) => {
        state.LoadingDirectors = true;
      })
      .addCase(getDirectors.fulfilled, (state, action) => {
        state.Directors = action.payload;
        state.LoadingDirectors = false;
      })
      .addCase(getDirectors.rejected, (state) => {
        state.LoadingDirectors = false;
      });
  },
});

export const { setIncludeDeleted } = directorsTableSlice.actions;

export const getDirectors = createAsyncThunk("directors/GetDirectors", async (includeDeleted: boolean) => {
  const directorsService = container.get<IDirectorsService>(SERVICE_TYPES.DirectorsService);
  return await directorsService.getDirectors(includeDeleted);
});

export const selectDirectors = (state: RootState) => state.directors.Directors;
export const selectIncludeDeleted = (state: RootState) => state.directors.IncludeDeleted;
export const selectLoadingDirectors = (state: RootState) => state.directors.LoadingDirectors;

export default directorsTableSlice.reducer;
